import { useLocation } from "wouter";
import axios, { AxiosResponse, AxiosError, InternalAxiosRequestConfig, AxiosHeaders } from "axios";
import API_URL from "@/config";
import { useToast } from "@/hooks/use-toast";

// import API_URL from "src/config";

let isToastShown = false;

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: API_URL,
});

// Request interceptor to add the token if available
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      if (config.headers) {
        if (config.headers instanceof AxiosHeaders) {
          config.headers.set("Authorization", `Bearer ${token}`);
        } else {
          config.headers = new AxiosHeaders().set("Authorization", `Bearer ${token}`);
        }
      } else {
        config.headers = new AxiosHeaders().set("Authorization", `Bearer ${token}`);
      }
    }
    return config;
  },
  (error: AxiosError) => Promise.reject(error)
);

// Setup response interceptors inside the component or hook
export const setupAxiosInterceptors = (navigate: any, params?: Record<string, any>, toast?: any): void => {
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      if (error.response && (error.response.status === 401)) {
        if (!isToastShown) {  // Only show toast if it hasn't been shown yet
          toast({
            title: "Session Expired!",
            description: "Redirecting to login page...",
          })
          isToastShown = true;  // Set the flag to true after the toast is shown
        }
        sessionStorage.clear();
        localStorage.clear();
        navigate("/")
      }
      return Promise.reject(error);
    }
  );
};

export const useAxiosSetup = () => {
  const [location,navigate] = useLocation();
  const toast = useToast();
  setupAxiosInterceptors(navigate, {},toast);
};



export default axiosInstance;
